import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {environment} from "@env/environment";
import {PlatformFeature} from "./platform-feature.model";
import {MasterDetailCrudComponent} from "@ui-webkit/components/crud-master-detail/master-detail-crud.component";

@Component({
  selector: 'app-feature-config-features',
  standalone: true,
  imports: [CommonModule, MasterDetailCrudComponent],
  templateUrl: './feature-config-features.component.html'
})
export class FeatureConfigFeaturesComponent {
  protected modelType = PlatformFeature;
  protected apiEndpointRoot = `${environment.apiSecurityHost}/platform/rbac/features`;
  protected apiEndpointPOSTTemplate = '/{code}';

  protected formTitle: string = 'Platform Feature';
  protected formSubtitle: string = 'Add or edit a specific feature.';
  protected tableTitle: string = 'Platform Features';
  protected tableSubtitle: string = 'Platform features are used to link functionality to a module.';

}
